import Stack from '@mui/material/Stack'
import React from 'react'
import { LinkingItem } from '../../Linking.types'
import { EmptyPlaceholder } from '../../../../shared/components/EmptyPlaceholder'
import { Group } from '../../Linking.types'
import Typography from '@mui/material/Typography'
import LinkableItemsModalListItem from './LinkableItemsModalListItem'
import SvgIcon from '@mui/material/SvgIcon'

type LinkableItemsModalListProps = {
    items: LinkingItem[]
    groups?: Group[]
    parentGroupName?: string
    childrenGroupName?: string
    checkIfSelected: (item: LinkingItem) => boolean
    onSelect: (item: LinkingItem, selected: boolean) => void
    itemDisplayName: { singular: string; plural: string }
}

const LinkableItemsModalList = ({
    items,
    groups,
    parentGroupName,
    childrenGroupName,
    onSelect,
    checkIfSelected,
    itemDisplayName,
}: LinkableItemsModalListProps) => {
    const isEmpty = !items?.length

    if (isEmpty) {
        return (
            <Stack
                flex={1}
                direction="column"
                gap={1}
                px={2}
                py={2.75}
                bgcolor="figma.grayscale.tier7"
                borderRadius="16px"
            >
                <EmptyPlaceholder title="" subtitle={`No available ${itemDisplayName.plural}`} />
            </Stack>
        )
    }

    const renderItem = (item: LinkingItem, isLastItem: boolean) => {
        return (
            <LinkableItemsModalListItem
                key={item._id}
                item={item}
                parentGroupName={parentGroupName}
                childrenGroupName={childrenGroupName}
                isLastItem={isLastItem}
                checkIfSelected={checkIfSelected}
                onSelect={onSelect}
            />
        )
    }

    if (groups?.length) {
        return (
            <Stack direction="column" gap={4.5}>
                {groups.map((group) => {
                    const count = group.items.filter(checkIfSelected).length
                    return (
                        <Stack key={group.id} direction="column" gap={2}>
                            <Stack
                                direction="row"
                                gap={1}
                                alignItems="center"
                                position="sticky"
                                top={0}
                                py={1}
                                my={-1}
                                zIndex={1}
                                bgcolor="background.paper"
                            >
                                {group.icon && (
                                    <SvgIcon
                                        component={group.icon}
                                        inheritViewBox
                                        fontSize="small"
                                        style={{
                                            fontSize: '14px',
                                        }}
                                    />
                                )}
                                <Stack direction="row" alignItems="center" gap={1.5}>
                                    <Typography variant="16x500" color="figma.grayscale.textHier1">
                                        {group.name}
                                    </Typography>
                                    <Typography variant="14x500" color="figma.grayscale.textHier2">
                                        {count} count
                                    </Typography>
                                </Stack>
                            </Stack>
                            {group.items.map((item, index) => renderItem(item, index === group.items.length - 1))}
                        </Stack>
                    )
                })}
            </Stack>
        )
    }

    return (
        <Stack direction="column" gap={2}>
            {items.map((item, index) => renderItem(item, index === items.length - 1))}
        </Stack>
    )
}

export default LinkableItemsModalList
